import {
  showErrorMessage,
  showSuccessMessage,
} from '../../../components/ToastComponent/store/toastMiddleware';
import { type AppDispatch } from '../../../redux/store';
import { getDeposit, updateDeposit, payDeposit, closeDeposit, getUnsettledDepositPayments, updateDepositPaymentStatus, getDepositReceipt } from './depositMiddleware';
import { type DepositPayment, type Deposit, type DepositClose, type DepositReceiptData } from './depositTypes';

export const updateDepositAction = async (
  dispatch: AppDispatch,
  payload: Deposit
) => {
  const data = {
    ...payload,
  };
  const res = await dispatch(updateDeposit(data));

  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('Deposit added Successfully'));
    // Return the depositNumber to fetch receipt
    return res.payload;
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error updating deposit'));
    return false;
  }
};

export const getDepositAction = async (
  dispatch: AppDispatch,
  payload: { branch?: string, phoneNumber?: string }
) => {
  const res = await dispatch(getDeposit(payload));
  console.log(res);
};

export const depositPaymentAction = async (
  dispatch: AppDispatch,
  payload: DepositPayment
) => {
  const data = {
    ...payload,
  };
  const res = await dispatch(payDeposit(data));

  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('Deposit payment Successful'));
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error on deposit payment'));
    return false;
  }
};

export const depositCloseAction = async (
  dispatch: AppDispatch,
  depositNumber: string,
  payload: DepositClose
) => {
  const data = {
    ...payload,
  };
  const res = await dispatch(closeDeposit({ depositNumber, data }));

  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('Deposit closed successfully'));
    return res.payload;
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error closing deposit'));
    return null;
  }
};

export const getUnsettledDepositPaymentsAction = async (
  dispatch: AppDispatch,
  payload: { branch?: string }
) => {
  const res = await dispatch(getUnsettledDepositPayments(payload));
  console.log('res', res);
  return res;
};

export const updateDepositPaymentStatusAction = async (
  dispatch: AppDispatch,
  id: string,
  status: string
) => {
  const res = await dispatch(updateDepositPaymentStatus({ id, status }));

  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage(`Payment ${status === 'cash_settled' ? 'approved' : status} successfully`));
    return res.payload;
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error updating payment status'));
    return null;
  }
};

export const getDepositReceiptAction = async (
  dispatch: AppDispatch,
  depositNumber: string
): Promise<{ receipt: DepositReceiptData } | null> => {
  const res = await dispatch(getDepositReceipt(depositNumber));

  if (res.meta.requestStatus === 'fulfilled') {
    return res.payload as { receipt: DepositReceiptData };
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error fetching receipt'));
    return null;
  }
};
